import {store} from '../../../store';

export async function uploadFileToBlob(file, fileName) {
  const jwtToken = store.getState().login.token;

  const headers = new Headers();
  headers.append('Authorization', 'Bearer ' + jwtToken);
  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[arr.length - 1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {type: mime});
  }
  const formData = new FormData();
  formData.append('file', dataURLtoFile(file, fileName));

  const response = await fetch(`/api/Service/uploadfile`, {
    method: 'POST',
    headers: headers,
    body: formData,
  });
  if (!response.ok) {
    throw response.status;
  }
  const responseText = await response.text();
  return responseText;
}
